import React from "react";
import RenderImageSlider from "../ComponentRenders/RenderImageSlider";
import LayoutNode, { getNodeComponentAttributeValue } from "../Definitions/LayoutNode";
import { UserContext } from "../Definitions/UserContext";
import { wBComponentTypeNames } from "../Definitions/WBComponentTypeNames";
import RenderNavigationList from "../ComponentRenders/RenderNavigationList";
import RenderBeforeAndAfter from "../ComponentRenders/RenderBeforeAndAfter";
import RenderVideoPlayer from "../ComponentRenders/RenderVideoPlayer";
import RenderNavigationBar from "../ComponentRenders/RenderNavigationBar";
import RenderButtonDropDown from "../ComponentRenders/RenderButtonDropdown";
import RenderPopup from "../ComponentRenders/RenderPopup";
import { GetPopupCookieName, getCookie, hasClosedPopup, hasSubmittedPopup } from "../Utilities/CookieUtils";
import SubscriptionThankyou from "../ComponentRenders/SubscriptionThankyou";
import RenderTabMobileMenu from "../BusinessControls/RenderTabsMobileMenu";
import RenderDormantBookButton from "../ComponentRenders/RenderDormantBookButton";
import RenderButton from "../ComponentRenders/RenderButton";

export default function GenericDynamicComponent({dataKey,node,context}:{dataKey:string,node:LayoutNode,context:UserContext}){


    switch(dataKey){
        case wBComponentTypeNames.imageSlider:
            return <RenderImageSlider component={node} screenSize={0} userContext={context} isEditor={false} children={undefined} />;

        case wBComponentTypeNames.beforeAndAfter:
           return <RenderBeforeAndAfter component={node} screenSize={0} userContext={context} isEditor={false} children={undefined} />;
           case wBComponentTypeNames.navigationBar:
            return <RenderNavigationBar  node={node} userContext={context} />;
        case wBComponentTypeNames.navigationList:
             return <RenderNavigationList  node={node} isEditor={ (window as any).isEditor == true }/>;
        case wBComponentTypeNames.videoPlayer:
            return <RenderVideoPlayer component={node} />;
        case wBComponentTypeNames.button: // bind dropdownmenu when button is presetn
            return <RenderButtonDropDown component={node} />;
        case wBComponentTypeNames.tabMobileMenu:
            return <RenderTabMobileMenu node={node} />;
        case wBComponentTypeNames.popup:

            //don't return the component if the popup has been closed or submitted
            let title = getNodeComponentAttributeValue(node, "pop-title") ?? "";

            title = title.replace(/ /g, "").toLowerCase();

            let val = getCookie(GetPopupCookieName()+title);

            if(val != hasClosedPopup&&val!=hasSubmittedPopup && !window.location.pathname.includes("/thank-you/")){ // omit popup on thank you page always
                return <RenderPopup component={node} userContext={context}  />;
            }
            else
            {
                return <></>
            }

        case wBComponentTypeNames.subscriptionThankYou:
            return <SubscriptionThankyou userContext={context}/>;
        case wBComponentTypeNames.dormantButton:
            if (context.isDormant || (window as any).isEditor == true)
                return <RenderDormantBookButton component={node} website={context.websitename ?? ""} siteData={context} />;
            else { // pass default context in as a booknow button if this is actually an active account

                let btnText = node.componentAttributes["buttonText"] ?? "Book Now";
                if(btnText.trim().length==0){
                    btnText="Book Now";
                }
                node.content = btnText;

                return <RenderButton classAdd=" w-full h-full " component={node} screenSize={0} isEditor={(window as any).isEditor == true} userContext={context} >{btnText}</RenderButton>;


            }
        default:
            return <></>
    }

}